export const WORKGROUP_TREE_NAME = "WORKGROUP_TREE_NAME";
